// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { MUST_SEARCH_AT_LEAST_ONE_VALUE } from 'errors'
import {
  assembleQuery,
  fetchRadiosByQuery,
  makePaginationParams,
} from 'helpers/api'

// operator mapping for each Radio Lookup input.
export const createSearchObject = (d, k) => {
  const f = ['txPowerMax', 'bandwidth', 'throughput']
  const value = d[k]
  const o = {
    field: k,
    operator: 'LIKE',
    value,
  }

  // fields in f should search for EQ
  if (~f.indexOf(k)) {
    o.operator = 'EQ'
  }

  // the input field for radio code could actually have a favorite radio code.
  // determine if it should support favorites
  // TODO NEXT - determine if this works with latest radioCode requirements allowing hyphens
  if (k === 'radioCode' && ~value.indexOf('-')) {
    o.value = value.substr(0, value.indexOf('-'))
  }

  // if the field is 'bandwidth' or 'throughput' AND
  // if the value has a ':', operator should be BETWEEN
  if (~value.indexOf(':')) {
    const v = value.split(':')
    o.valueMin = v[0]
    o.valueMax = v[1]
    o.operator = 'BETWEEN'
    delete o.value
  }

  return o
}

const fetchData = formArgs => {
  const {
    formProps,
    formValues,
    queryBasis = [],
    includeFlags = [],
    submittedFormIsPristine,
  } = formArgs

  const d = formValues

  // form must have at least one value
  // throws error message if false
  const search = queryBasis ? [...queryBasis] : []
  let hasValue = false

  Object.keys(d).forEach(k => {
    // ignore pagination values when building the search query
    if (k === 'pagination' || k === 'bandId') {
      return
    }

    // these values can be null and if they are, searching for '%'
    // will omit any radios which have these as null
    if ((k === 'architecture' || k === 'modulationType') && d[k] === '%') {
      return
    }

    if (!hasValue && d[k].length && k !== 'bandId') {
      hasValue = true
    }

    if (d[k] !== undefined && d[k].toString().length && k !== 'bandId') {
      search.push(createSearchObject(d, k))
    }
  })

  // if there's no search value, don't hit API
  if (!hasValue) {
    throw new Error(MUST_SEARCH_AT_LEAST_ONE_VALUE)
  }

  const page = (
    formValues.pagination && submittedFormIsPristine(formProps.form)
      ? +formValues.pagination.page
      : 0
  )

  // size of results set in API response - default to 500 count
  const size = 500

  const paginationParams = makePaginationParams({
    page,
    size,
  })

  const query = [{
    field: 'search',
    value: [search],
  },
  ...includeFlags,
  ...paginationParams,
  ]

  return fetchRadiosByQuery(assembleQuery(query))
}

export default fetchData
